import { useEffect } from 'react';

import { logger } from '@/lib/logger';

/**
 * Initialize xprops bridge integration and track parent responsiveness
 */
export function useInitXprops(): void {
  useEffect(() => {
    if (window.xprops?.setBridgeAppDetails) {
      window.xprops.setBridgeAppDetails({
        appName: 'checkoutuinodeweb',
        pageName: 'weasley',
      });
    }
  }, []);

  useEffect(() => {
    if (window.xprops?.isParentResponsive) {
      window.xprops
        .isParentResponsive()
        .then(responsive => {
          const isParentResponsive = String(responsive);
          window.DD_RUM?.setGlobalContextProperty?.(
            'isParentResponsive',
            responsive,
          );

          logger.fpti('parent_responsive_check', {
            event_name: 'parent_responsive_check',
            is_parent_responsive: responsive,
          });

          logger.info('parent_responsive', {
            isParentResponsive,
          });

          logger.metric('parent_responsive', {
            dimensions: {
              isParentResponsive,
            },
          });
        })
        .catch(error => {
          const errorMessage =
            error instanceof Error ? error.message : 'Unknown error';

          window.DD_RUM?.setGlobalContextProperty?.(
            'isParentResponsive',
            undefined,
          );

          logger.error('parent_responsive_check_error', {
            error: errorMessage,
          });

          logger.metric('parent_responsive_error');
        });
    }
  }, []);
}
